import React from "react"
import { useFormikContext } from "formik"
import MySelectGetAllDataFromServer from "@common-utils/fields/MySelectGetAllDataFromServer"
import MyTooltip from "@common-utils/MyTooltip"
import { CONST_PERSONNEL_TEMPLATE_CATEGORIE_CODE_DMS } from "@common-constants/*"
import { IFormValuesModel } from "./LogicEntretienTel"
import { CONST_API_UTILS_GET_TEMPLATES_ENDPOINT } from "../../../../../../endpoints"

interface IProps {
     onTemplateSelect: (templateId: number) => void
     onEditTemplate: (templateId: number) => void
     onCreateTemplate: () => void
     onDeleteTemplate: (templateId: number) => void
     refreshKey?: number
}

const TemplateSelectorEntretienTel: React.FC<IProps> = ({ onTemplateSelect, onEditTemplate, onCreateTemplate, onDeleteTemplate, refreshKey = 0 }) => {
     const { values, setFieldValue, errors } = useFormikContext<IFormValuesModel>()

     return (
          <div className="row mb-5">
               <label className="col-lg-4 col-form-label fw-bold fs-6 required">Template</label>
               <div className="col-lg-8">
                    <MySelectGetAllDataFromServer
                         // We do NOT use 'key' here anymore to avoid unmounting the component
                         name={"template"}
                         value={values.template}
                         onChange={val => {
                              setFieldValue("template", val)
                              if (val) onTemplateSelect(val as number)
                         }}
                         url={CONST_API_UTILS_GET_TEMPLATES_ENDPOINT}
                         payload={{
                              includeTeam: true,
                              categorie: CONST_PERSONNEL_TEMPLATE_CATEGORIE_CODE_DMS,
                              // We inject the refresh key here. Changing this prop will trigger the
                              // component's internal useEffect to refetch data without losing the current selection.
                              _refresh: refreshKey,
                         }}
                         isInvalid={!!errors.template}
                         placeholder="Sélectionnez un modèle..."
                    />

                    <div className="d-flex justify-content-between align-items-center mt-2">
                         <div className="d-flex gap-3">
                              {values.template && (
                                   <>
                                        <MyTooltip title={"Supprimer le template sélectionné"}>
                                             <span className="btn btn-icon btn-sm btn-light-danger" onClick={() => onDeleteTemplate(values.template as number)}>
                                                  <i className="fas fa-trash" />
                                             </span>
                                        </MyTooltip>
                                        <MyTooltip title={"Editer le template sélectionné"}>
                                             <span className="btn btn-icon btn-sm btn-light-warning" onClick={() => onEditTemplate(values.template as number)}>
                                                  <i className="fas fa-edit" />
                                             </span>
                                        </MyTooltip>
                                   </>
                              )}
                         </div>

                         <MyTooltip title={"Créer un nouveau template"}>
                              <button type="button" className="btn btn-sm btn-light-success fw-bold" onClick={onCreateTemplate}>
                                   <i className="fas fa-plus-circle me-1" /> Nouveau
                              </button>
                         </MyTooltip>
                    </div>
                    {errors.template && <div className="text-danger mt-1">{errors.template}</div>}
               </div>
          </div>
     )
}

export default TemplateSelectorEntretienTel
